import { useTranslation } from 'react-i18next';
import SimpleLayout from '@/layouts/SimpleLayout';

export default function SpecificBased() {
  const { t, i18n } = useTranslation();

  // 强制使用日语显示内容
  const getJaText = (key: string) => {
    return t(key, { lng: 'ja' });
  };

  return (
    <SimpleLayout>
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 mt-24">
        <div className="mx-auto max-w-4xl">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl text-center mb-12">
            {getJaText('home.footer.specificBased')}
          </h1>
          <div className="mt-10">
            <div className="overflow-hidden bg-white shadow sm:rounded-lg">
              <div className="border-t border-gray-200">
                <dl>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.seller')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">株式会社Sparticle</dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.address')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      東京都中央区日本橋小伝馬町6-12 日本橋森ビル 3F
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.phone')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      03-3527-2828 {getJaText('home.footer.specificBasedContent.officeHours')}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.email')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      <a href="mailto:support@sparticle.com" className="text-indigo-600 hover:text-indigo-500">
                        support@sparticle.com
                      </a>
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.manager')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">金田 達也</dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.additionalFees')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {getJaText('home.footer.specificBasedContent.none')}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.cancellationPolicy')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {getJaText('home.footer.specificBasedContent.cancellationDetails')}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.deliveryTime')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {getJaText('home.footer.specificBasedContent.immediate')}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.paymentMethod')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {getJaText('home.footer.specificBasedContent.creditCard')}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.paymentTiming')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {getJaText('home.footer.specificBasedContent.creditCardTiming')}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.price')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {getJaText('home.footer.specificBasedContent.priceDetails')}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      {getJaText('home.footer.specificBasedContent.systemRequirements')}
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      <p>{getJaText('home.footer.specificBasedContent.recommendedEnvironment')}</p>
                      <ul className="list-disc pl-5 mt-2">
                        <li>{getJaText('home.footer.specificBasedContent.browsers')}</li>
                        <li>{getJaText('home.footer.specificBasedContent.internet')}</li>
                        <li>{getJaText('home.footer.specificBasedContent.devices')}</li>
                      </ul>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimpleLayout>
  );
}
